import React from 'react';

function SectionDivider() {
  return (
    <div className="w-[70%] max-w-[1000px] h-[2px] my-4 mx-auto bg-gradient-to-r from-transparent via-[var(--secondary-color)] to-transparent"></div>
  )
}
export default SectionDivider